import { cycloneApiClient } from '@/shared/api/core/axios-instance';

import type {
  CreateProjectRequest,
  ProjectDetail,
  ProjectResponse,
  UpdateProjectRequest,
} from '@/entities/project/domain/types';

const PROJECT_BASE_URL = '/projects';

export const projectApi = {
  create: async (data: CreateProjectRequest): Promise<ProjectResponse> => {
    const response = await cycloneApiClient.post<ProjectResponse>(PROJECT_BASE_URL, data);
    return response.data;
  },

  getById: async (projectId: number): Promise<ProjectDetail> => {
    const response = await cycloneApiClient.get<ProjectDetail>(`${PROJECT_BASE_URL}/${projectId}`);
    return response.data;
  },

  update: async (projectId: number, data: UpdateProjectRequest): Promise<ProjectDetail> => {
    const response = await cycloneApiClient.patch<ProjectDetail>(`${PROJECT_BASE_URL}/${projectId}`, data);
    return response.data;
  },
};
